// Textes centralisés de l'onboarding (F4 états vides, F1 assistant) — modifiables sans toucher aux composants.
export const EMPTY = {
  dashboard: { title: "Votre tableau de bord se remplira dès votre premier bien.", cta: "Créer mon premier bien", demo: true },
  biens: { title: "Ajoutez votre premier bien en moins d'une minute.", cta: "Ajouter un bien", demo: true },
  locatairesNoProp: { title: "Créez d'abord le bien que vous louez.", cta: "Créer un bien" },
  locataires: { title: "Ajoutez le locataire de « {bien} ».", cta: "Ajouter un locataire" },
  baux: { title: "Un bail relie un bien et un locataire, et déclenche vos quittances.", cta: "Créer un bail" },
  quittances: { title: "Vos quittances apparaîtront ici dès qu'un bail est actif.", cta: "Créer un bail" },
  documents: { title: "Rangez ici baux, diagnostics et états des lieux.", cta: "Ajouter un document" },
  needProperty: "Créez d'abord le bien que vous louez.",
};

export const WIZARD = {
  welcomeTitle: "Bienvenue !",
  welcomeText: "En 3 étapes, votre première location est prête.",
  steps: ["Mon bien", "Mon locataire", "Mon bail"],
  vacant: "Mon bien est vacant",
  successTitle: "Votre première location est prête",
  resume: "Vous n'avez pas terminé la configuration de votre première location.",
};

export const HELP = {
  irl: "L'indice de référence des loyers (INSEE) permet de réviser le loyer une fois par an, à la date anniversaire du bail.",
  depot: "Somme versée à l'entrée et restituée au départ. Plafond : 1 mois de loyer hors charges en vide, 2 mois en meublé.",
  echeance: "Jour du mois où le loyer est dû. Sert à l'avis d'échéance et aux relances.",
  charges: "Provision : avance régularisée chaque année sur justificatifs. Forfait : montant fixe, sans régularisation.",
  meuble: "Meublé : bail d'1 an (9 mois étudiant), dépôt jusqu'à 2 mois, liste d'équipements obligatoire. Vide : bail de 3 ans, dépôt d'1 mois.",
  regul: "Une fois par an, comparez les provisions versées aux charges réelles : vous remboursez le trop-perçu ou réclamez le complément, justificatifs à l'appui.",
  quittance: "L'avis d'échéance réclame le loyer avant paiement. La quittance prouve qu'il a été payé : elle n'est remise qu'après encaissement complet.",
};
